import React from 'react';
import PropTypes from 'prop-types';

import Enabled from './enabled';
import Users from './users';

export default function CompanyGridAccess({ companyGrid, users, onChange }) {
  return (
    <React.Fragment>
      <Enabled companyGrid={companyGrid} onChange={onChange} />
      {companyGrid.enabled && <Users companyGrid={companyGrid} users={users} onChange={onChange} />}
    </React.Fragment>
  );
}

CompanyGridAccess.propTypes = {
  companyGrid: PropTypes.shape({
    enabled: PropTypes.bool,
  }).isRequired,
  users: PropTypes.array,
  onChange: PropTypes.func,
};
